import { useEffect, useRef } from 'react'
import { IViewModel } from './interface'
import { useRouter } from 'next/router'

/**
 * Create ref to the functional component (It will not re-run on each render)
 * @param ViewModelConstructor
 * @param props context
 * @return ViewModelConstructor
 */

export function useViewModel<P extends object, S, A>(
	props: P,
	ViewModelConstructor: IViewModel<P, S, A>,
) {
	const router = useRouter()

	let vmRef = useRef(
		ViewModelConstructor({
			...props,
			router,
		}),
	)
	return vmRef.current
}
